import { Icon } from '@iconify/react'
// @ts-ignore

const ProviderCard = ({requestDetails}: {requestDetails: any}) => {

    return (
        <div className="hospital-card">
            <div className="hospital-card-content">
                <img
                    // @ts-ignore
                    src={`${window.WEB_LINK}${requestDetails?.logo}`}
                    alt={requestDetails?.providerName}
                    className="hospital-card-image"
                   
                />
                <div className="hospital-card-details">
                    <div className="hospital-card-header">
                        <Icon icon="mdi:hospital-building" className="hospital-card-icon" />
                        <h2 className="hospital-card-name">{requestDetails?.providerName}</h2>
                    </div>

                    <div className="hospital-card-location">
                        <Icon icon="mdi:map-marker" />
                        <span>{requestDetails?.mainAddress}</span>
                    </div>

                    <div className="hospital-badges">
                        {requestDetails?.accredations?.map((accreditation, index) => (
                            <span key={index} className="hospital-badge">
                                {accreditation}
                            </span>
                        ))}
                    </div>

                    <p className="hospital-card-description">
                        {requestDetails?.profileSummary}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProviderCard